import { useEffect, useState } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { localStorageAuthUserData } from "./helper/commanFunc";
import { verifyToken } from "./api/auth";
import toast from "react-hot-toast";

const ProtectedRoute = ({ allowedRole }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const { token } = localStorageAuthUserData();

      if (!token) {
        toast.error("Please login to continue.");
        return navigate("/login", { replace: true });
      }

      try {
        const { data } = await verifyToken({ token });
        const { role } = data;

        if (!allowedRole.includes(role)) {
          toast.error("Access denied.");
          return navigate("/", { replace: true });
        }

        setLoading(false);
      } catch (err) {
        console.error("Token verification failed:", err);
        toast.error("Session expired. Please login again.");
        localStorage.clear() 
        navigate("/login", { replace: true });
      }
    };

    checkAuth();
  }, [allowedRole, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
